var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokMobileComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 35,
  height: 34,
  viewBox: "0 0 35 34",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.5 0C27.165 0 35 6.716 35 15c-1 11.5-14.5 18.5-16 18.5-1.41 0-1.494-.882-1.5-3.476V29.5C6.5 29.5 0 23.284 0 15S7.835 0 17.5 0m-8 13.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m8 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m8 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
})));
export default SvgTiktokMobileComment;